module.exports = __webpack_public_path__ + "img/43_8.07d76aab.png";